import { render } from "./CorrectPage.vue?vue&type=template&id=e57f64e6&scoped=true"
import script from "./CorrectPage.vue?vue&type=script&lang=js"
export * from "./CorrectPage.vue?vue&type=script&lang=js"

import "./CorrectPage.vue?vue&type=style&index=0&id=e57f64e6&scoped=true&lang=css"

import exportComponent from "C:\\M1\\projects__gitlab\\comed-station-4-energy-management--tablet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57f64e6"]])

export default __exports__